import { get } from 'vuex-pathify';

export default {
  computed: {
    zdmDataSources: get('admin/modulesMapping@zdm_data.datasources'),
  },
  methods: {
    showExtrasTab(tab) {
      const { extras } = this.$refs;
      if (!extras) {
        return;
      }
      extras.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      extras.setCurrentTab(tab);
    },
  },
};
